import styles from './styles.module.scss';
import HamburgerButton from './hamburger-button';
import { useState } from 'react';
import Sidenav from 'components/sidenav';
import { isImpersonate } from 'utils/impersonate';

function MenuButton() : JSX.Element {
  const[menuOpen, setMenuOpen] = useState(false);

  const toogleMenu = () : void => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div id={styles['biobar-application-logo']}>
      <div className={styles['biobar-logo']}>
        <img src={require('../../assets/logo.png')} />
        {isImpersonate() && <p>IMPERSONATE</p>}
      </div>
      <HamburgerButton
        isOpen={menuOpen}
        onClick={toogleMenu}/>

      { menuOpen &&
        <Sidenav
          onClick={toogleMenu}/>
      }
    </div>
  );
}

export default MenuButton;